import { FormattedMessage, useIntl } from 'react-intl';

import { FormField } from '../../../../forms/formField/index';
import { numbersOnly } from '../../../../forms/helpers/normalisers';

const TurnoverQuestion = (props) => {
    const intl = useIntl();
    const { onChange } = props;

    return (
        <FormField
            label={
                <FormattedMessage
                    id="_.your_company.last_twelve_months_turnover"
                    defaultMessage="Last 12 months turnover"
                />
            }
            className="fs-exclude"
            name="annualTurnover"
            id="annualTurnover"
            onChangeHandler={onChange}
            normalize={numbersOnly}
            format={(value) => (value ? intl.formatNumber(value) : '')}
            data-testid="annual-turnover-field"
        />
    );
};

// eslint-disable-next-line import/no-default-export
export default TurnoverQuestion;
